<template>
  <vs-sidebar
    default-index="1"
    :parent="parent"
    :hiddenBackground="$store.getters['IS_SIDEBAR_ACTIVE']"
    class="sidebarx"
    spacer
    v-model="$store.getters['IS_SIDEBAR_ACTIVE']"
    :click-not-close="$store.getters['IS_SIDEBAR_ACTIVE']"
  >
     <vs-sidebar-group title="Sentenance" open>
      <vs-sidebar-item :to="'/overview'" index="1" icon="cloud_queue">
        Overview
      </vs-sidebar-item>
      <vs-sidebar-item :to="'/report'" index="2" icon="description">
        Report
      </vs-sidebar-item>
      <vs-sidebar-item :to="'/smartfarmdemo/dashboard'" index="3" icon="dashboard">
        Dashboard
      </vs-sidebar-item>
      <vs-sidebar-group title="Device Mangement">
        <vs-sidebar-item :to="'/sensor'" index="2.1" icon="signal_cellular_alt">
          Device
        </vs-sidebar-item>
        <vs-sidebar-item :to="'/gateway'" index="2.2" icon="router">
          Gateway
        </vs-sidebar-item>
        <vs-sidebar-item :to="'/Alert'" index="2.3" icon="report_problem">
          Alert
        </vs-sidebar-item>
      </vs-sidebar-group>
    </vs-sidebar-group>

    <footer-sidebar slot="footer"></footer-sidebar>
  </vs-sidebar>
</template>

<script>
import FooterSidebar from "../FooterSidebar.vue";
export default {
  name: "BetagroSidebar",
  components: {
    FooterSidebar,
  },
  data() {
    return {};
  },
};
</script>

<style>
</style>